import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { pains } from '../data/content';
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="paper-grain relative bg-shell py-16 sm:py-24" data-id="element-127" data-mp="2uy5m4yt3mvy0">
      <Container narrow className="relative" data-id="element-128" data-mp="2yzqz0k5mva87">
        <SectionHeading id="pain-heading" title="This kit is for you if…" align="center" data-id="element-129" data-mp="2yyfq65xbzca8" />

        <ul className="mx-auto mt-11 grid max-w-[760px] gap-3.5 sm:mt-14 sm:gap-4" data-id="element-130" data-mp="2l7axxowalm9x">
          {pains.map(pain => <li key={pain.lead} className="flex items-start gap-3.5 rounded-card border border-hairline bg-white p-5 shadow-paper sm:gap-4 sm:p-6" data-id="element-131" data-mp="2q0dkhd2njvgm">
              {/* cut-paper mark: a soft red dot inside a pale halo */}
              <span aria-hidden="true" className="mt-[7px] flex h-3.5 w-3.5 flex-none items-center justify-center rounded-full bg-alertSoft sm:mt-[9px]" data-id="element-132" data-mp="229848wssv15s">
                <span className="h-1.5 w-1.5 rounded-full bg-alert" data-id="element-133" data-mp="3rm98l2w66cum" />
              </span>

              <p data-id="element-134" data-mp="3nlyv7561sk5q">
                <span className="font-display text-[18px] font-extrabold leading-[1.22] tracking-[-0.01em] text-ink sm:text-[21px]" data-id="element-135" data-mp="3nke09eftmz7c">
                  {pain.lead}
                </span>
                {pain.rest && <span className="mt-1.5 block text-[15px] font-semibold leading-[1.45] text-muted sm:text-[16px]" data-id="element-136" data-mp="h99d111o9rr">
                    {pain.rest}
                  </span>}
              </p>
            </li>)}
        </ul>
      </Container>
    </section>;
}